import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BillingFacade } from '@app/shared/+state/billing';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';

// If the user hasn't selected a plan yet, send them back to the your-plan page
@Injectable({
  providedIn: 'root',
})
export class PlanSelectionGuard  {
  constructor(
    private billingFacade: BillingFacade,
    private router: Router
  ) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.billingFacade.pendingSubscriptionChange$.pipe(
      map(({ inProgress }) => (inProgress ? inProgress : this.router.createUrlTree(['/settings/your-plan']))),
      take(1)
    );
  }
}
